import { List, Map } from 'immutable';
import { records as deviceRecords } from '@saucelabs/sl-module-devices-rdc';

import * as constants from './../constants';

const initialState = Map({
  availableDeviceIds: [],
  currentFacets: null,
  initialFacets: null,
  items: List(),
  loading: false,
  sessionAvailable: false,
  sortMode: constants.DEVICE_SORT_MODES.STARRED_FIRST,
});

const sortResolutions = (resA, resB) => Number(resA.split('x')[0]) - Number(resB.split('x')[0]);

const sortNumericStrings = (el1, el2) => el1.localeCompare(el2, undefined, { numeric: true });

export const prepareFacets = (facets) => Object.entries(facets).reduce((acc, [facet, value]) => {
  if (facet === 'resolution') {
    return { ...acc, [facet]: Object.keys(value).sort(sortResolutions) };
  }

  if (facet === 'osVersion' || facet === 'screenSize') {
    return { ...acc, [facet]: Object.keys(value).sort(sortNumericStrings).reverse() };
  }

  return { ...acc, [facet]: Object.keys(value).sort() };
}, {});

const devicesReducer = (state = initialState, { type, payload = {} }) => {
  switch (type) {
    case constants.MOBILE_DEVICES_FETCH.REQUEST:
      return state.set('loading', true);
    case constants.MOBILE_DEVICES_FETCH.SUCCESS: {
      const payloadItems = payload.entities || [];
      const items = List(payloadItems.map((device) => new deviceRecords.DeviceDescriptor(device)));
      const preparedFacets = payload.facets && prepareFacets(payload.facets);

      return state.withMutations((mutable) => (
        mutable.set('loading', false)
          .set('items', items)
          .set('currentFacets', preparedFacets || null)
          .update('initialFacets', (initialFacets) => initialFacets || preparedFacets || null)));
    }
    case constants.MOBILE_DEVICES_FETCH.FAILURE:
      return state.set('loading', false);
    case constants.MOBILE_AVAILABLE_DEVICE_IDS_FETCH.SUCCESS:
      return state.set('availableDeviceIds', payload);
    case constants.MOBILE_AVAILABLE_DEVICE_IDS_FETCH.FAILURE:
      return state.set('availableDeviceIds', initialState.get('availableDeviceIds'));
    case constants.MOBILE_SESSION_AVAILABLE_FETCH.SUCCESS:
      return state.set('sessionAvailable', payload.manualSessionAvailable);
    case constants.MOBILE_SESSION_AVAILABLE_FETCH.FAILURE:
      return state.set('sessionAvailable', initialState.get('sessionAvailable'));
    // TODO: refactor when Hackathon experiment gets cleaned up
    case constants.MOBILE_DEVICES_FACETS_CLEANUP:
      return state.merge({
        initialFacets: initialState.get('initialFacets'),
        currentFacets: initialState.get('currentFacets'),
      });
    case constants.SORT_DEVICES:
      return state.set('sortMode', Object.values(constants.DEVICE_SORT_MODES).includes(payload.sortMode) ? payload.sortMode : state.get('sortMode'));
    default:
      return state;
  }
};

export default devicesReducer;
export { initialState };
